var checkPasswordsMatchTimeout;

ko.bindingHandlers.checkPasswordsMatch = {
    update: function(element, valueAccessor, allBindingsAccessor, vm, bindingContext) {

        var value = valueAccessor();
        var password2 = ko.unwrap(value);
        var vm = bindingContext.$rawData;

        if (!vm.password() || vm.password() == "") {
            return;
        }

        clearTimeout(checkPasswordsMatchTimeout);
        checkPasswordsMatchTimeout = setTimeout(function () {
            if (vm.password() !== vm.password2()) {
                vm.errorMessage("Passwords do not match");
                vm.error(true);
            } else {
                vm.errorMessage("");
                vm.error(false);
            }
        }, 1200);

    }
};


function checkPasswordStrength(password) {
  var strength = 0;
  if (password.match(/[a-z]+/)) {
    strength += 1;
  }
  if (password.match(/[A-Z]+/)) {
    strength += 1;
  }
  if (password.match(/[0-9]+/)) {
    strength += 1;
  }
  if (password.match(/[$@#&!]+/)) {
    strength += 1;

  }

  return strength;
}

ko.bindingHandlers.checkPasswordStrength = {
    update: function(element, valueAccessor, allBindingsAccessor, vm, bindingContext) {

        var value = valueAccessor();
        var password = ko.unwrap(value);
        var vm = bindingContext.$rawData;

        if (password) {
           vm.passwordStrength(checkPasswordStrength(password));
        }

        return false;

    }
};